import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';


@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.apiUrl;

    /**
     * Constructor
     * @param http - Angular Http Client
     */
    constructor(
        private http: HttpClient
    ) {
    }

    /**
     * GET: Request user profile
     * @param data - Forgot password data
     */
    public getProfile(): Observable<any> {
        return this.http.get(`${this.apiUrl}/usuarios/perfil/`);
    }

    /**
     * PUT: Update user photo
     * @param userPicture - base64 image
     */
    public updateProfile(userPicture: string): Observable<any> {
        return this.http.put(`${this.apiUrl}/usuarios/foto`, { imagem: userPicture  });
    }

    /**
     * PUT: Update user language
     * @param language - language code
     */
    putLanguage(language: string) {
        return this.http.put(`${this.apiUrl}/usuarios/idioma`, { idioma: language });
    }

    /**
     * PUT: Update password for user
     * @param password - New password for authenticated user
     */
    changePassword(password: any) {
        return this.http.put(`${this.apiUrl}/usuarios/senha/alterar`, password );
    }

    /**
     * GET: Get activity history for user
     * @param page - Page number
     */
    getActivityHistory(page: number) {
        return this.http.get(`${this.apiUrl}/usuarios/registros/${page}`);
    }
}
